// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__23UI3","space":"Card_space__2Etf-","shrink":"Card_shrink__n7IC4","checkbox":"Card_checkbox__jy5Q3","active":"Card_active__e_kZB"};